var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMountain = function SvgMountain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 992,
    height: 236,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m330.636 233.379 145.328-150.94 145.328 150.94M181.479 233.379l145.329-150.94 72.724 75.408M368.073 39.58c7.297 0 13.158 6.087 13.158 13.665v1.242",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M394.388 39.58c-7.297 0-13.158 6.087-13.158 13.665v1.242M411.134 39.58c7.296 0 13.157 6.087 13.157 13.665v1.242M437.448 39.58c-7.296 0-13.157 6.087-13.157 13.665v1.242M377.643 2.31c7.296 0 13.157 6.088 13.157 13.666v1.242M403.957 2.31c-7.296 0-13.157 6.088-13.157 13.666v1.242M42.85 205.928c-18.18 0-33.73 11.18-40.788 27.33h81.695c-7.177-16.15-22.726-27.33-40.907-27.33ZM21.799 209.033v-72.674M21.798 187.79c8.39 0 15.19-20.134 15.19-44.971 0-24.837-6.8-44.972-15.19-44.972s-15.19 20.135-15.19 44.972 6.8 44.971 15.19 44.971ZM63.781 209.033v-72.674M63.902 187.79c8.39 0 15.19-20.134 15.19-44.971 0-24.837-6.8-44.972-15.19-44.972S48.71 117.982 48.71 142.82s6.801 44.971 15.19 44.971ZM897.596 234v-72.675M897.595 212.757c8.39 0 15.191-20.135 15.191-44.972s-6.801-44.971-15.191-44.971-15.191 20.134-15.191 44.971c0 24.837 6.801 44.972 15.191 44.972ZM935.871 234v-72.675M935.871 212.757c8.39 0 15.191-20.135 15.191-44.972s-6.801-44.971-15.191-44.971c-8.389 0-15.19 20.134-15.19 44.971 0 24.837 6.801 44.972 15.19 44.972ZM974.146 234v-72.675M974.147 212.757c8.389 0 15.19-20.135 15.19-44.972s-6.801-44.971-15.19-44.971c-8.39 0-15.191 20.134-15.191 44.971 0 24.837 6.801 44.972 15.191 44.972Z",
    stroke: "#C7AA3D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M705.453 117.861c9.689 1.863 16.028 11.429 14.353 21.491l-2.99 16.896c-1.794 10.062-11.004 16.646-20.693 14.907-9.688-1.863-16.028-11.429-14.353-21.492l2.99-16.895c1.794-10.063 11.005-16.647 20.693-14.907Z",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m719.567 140.719 3.11.621M720.524 136.87l3.23-1.369",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M680.933 152.893c-10.765-1.987-17.822-12.671-15.908-23.852l19.377 3.603-3.469 20.249Z",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M669.33 126.184c0-1.863.359-3.727.837-5.342l13.158 10.187M712.75 131.526c-.598.994-1.914 1.615-3.11 1.366-1.196-.248-2.033-1.118-2.392-2.236M809.395 158.112c.12-5.838 5.263-10.062 5.263-10.062l1.555 10.311c1.076 5.342-2.273 10.684-7.416 11.802-5.143 1.118-10.287-2.361-11.363-7.703l-2.034-10.186c8.014-1.74 15.311 5.838 17.464 11.429",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M803.175 153.266c-.956-3.478 1.555-6.087 1.555-6.087 2.991.372 5.503 2.981 6.101 5.839",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M808.797 170.658c2.751 7.206 3.588 17.268 3.708 26.213M779.493 158.112c.119-5.838 5.262-10.062 5.262-10.062l1.556 10.311c1.076 5.342-2.273 10.684-7.417 11.802-5.143 1.118-10.286-2.361-11.363-7.703l-2.033-10.186c8.014-1.74 15.31 5.838 17.463 11.429",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M773.272 153.266c-.957-3.478 1.555-6.087 1.555-6.087 2.99.372 5.502 2.981 6.1 5.839",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M778.895 170.658c2.751 7.206 3.588 17.268 3.707 26.213M749.589 158.112c.12-5.838 5.263-10.062 5.263-10.062l1.555 10.311c1.077 5.342-2.272 10.684-7.416 11.802-5.143 1.118-10.286-2.361-11.363-7.703l-2.033-10.186c8.014-1.74 15.31 5.838 17.463 11.429",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M743.37 153.266c-.957-3.478 1.555-6.087 1.555-6.087 2.99.372 5.502 2.981 6.1 5.839",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M748.991 170.658c2.751 7.206 3.588 17.268 3.708 26.213",
    stroke: "#C7AA3D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M755.33 73.262c-.119-.87-.957-1.49-1.794-1.367l-5.98 1.118c-.718.125-1.316.87-1.316 1.615v9.07c-1.794-.373-3.708.496-4.545 2.98-.12.25-.12.498-.12.746-.239 2.36 1.674 4.472 3.947 4.472 2.033 0 3.708-1.615 3.947-3.727V76.12l4.785-.87c.598-.248 1.196-1.117 1.076-1.987Zm-10.047 15.28c-.479 0-.837-.373-.837-.87 0-.496.358-.87.837-.87.478 0 .837.374.837.87 0 .498-.359.87-.837.87ZM765.019 101.711c-.119-.87-.837-1.615-2.153-1.243l-11.482 1.988c-.718.124-1.316.87-1.316 1.615v9.069c-1.794-.373-3.708.497-4.545 2.981-.12.249-.12.497-.12.746-.239 2.36 1.675 4.472 3.947 4.472 2.034 0 3.708-1.615 3.947-3.727v-12.05l10.287-1.739c.718-.249 1.675-1.118 1.435-2.112Zm-15.788 16.398c-.479 0-.838-.373-.838-.869 0-.497.359-.87.838-.87.478 0 .837.373.837.87 0 .496-.359.869-.837.869Z",
    fill: "#C7AA3D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M761.91 100.965v9.069c-1.794-.373-3.708.497-4.546 2.981-.119.249-.119.497-.119.746-.239 2.36 1.674 4.472 3.947 4.472 2.033 0 3.708-1.615 3.947-3.727V102.456l-3.229-1.491Zm-.838 13.789c-.478 0-.837-.372-.837-.869s.359-.87.837-.87c.479 0 .838.373.838.87s-.359.869-.838.869Z",
    fill: "#C7AA3D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M752.101 109.164c-.598 0-1.076-.497-1.196-1.118-.119-.621.359-1.242.957-1.366l11.842-1.615c.598-.124 1.196.373 1.315.994.12.621-.359 1.242-.957 1.366l-11.841 1.615c0 .124-.12.124-.12.124Z",
    fill: "#C7AA3D"
  })));
};
export default SvgMountain;